import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label, Alert,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"
import Shimmer from "react-shimmer-effect";

import { Link, Redirect, withRouter } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken, apiRequest } from '../../../../../services/adapters/kepegawaian/koreksiKehadiranService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from './Blocs/CreateBloc'
import DatePicker from '../../../../../helpers/ui/DatePicker'
import moment from 'moment'
import { addDays } from 'date-fns'

const reformatDate = (date, withDay = true) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]

    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0' + dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
}

var reformatOptionsEmployee = function (raw, is_revisi, revisi_pegawai_uuid) {
    return raw.map(function (data) {
        var newObj = {};
        if (is_revisi == 1) {
            if (data.employee_uuid == revisi_pegawai_uuid) {
                newObj["label"] = `${data.employee_nip} - ${data.employee_full_name}`;
                newObj["value"] = data.employee_uuid;
                newObj["isdisabled"] = false

            } else {
                newObj["label"] = `${data.employee_nip} - ${data.employee_full_name}`;
                newObj["value"] = data.employee_uuid;
                newObj["isdisabled"] = true;
            }
        } else {
            newObj["label"] = `${data.employee_nip} - ${data.employee_full_name}`;
            newObj["value"] = data.employee_uuid;
        }
        return newObj;
    });
};

class CreateView extends Component {
    queryParams = new URLSearchParams(window.location.search)
    source
    createBloc = new CreateBloc()
    indexBloc = new IndexBloc()
    timer

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "")
        : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "");
    is_revisi = this.queryParams.get('is_revisi');
    revisi_pegawai_uuid = this.queryParams.get('pegawai_uuid');
    constructor(props) {
        super(props)
        var hari_libur = [];
        var storage_libur = sessionStorage.getItem('holidays') ? JSON.parse(sessionStorage.getItem('holidays')) : [];
        storage_libur.map(function (item, i) {
            var libur = addDays(new Date(item), 0);
            hari_libur.push(libur);
        });

        this.state = {
            holidays_format_date: hari_libur,
            employeeOption: [],
            selectedCorrectionType: 2,
            adjustmentTypeVal: null,
            domicile: 1,
            oversea: 1,
            options: [],
            dinas: [],
            employeeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'employee_name',
                    order: 'asc'
                }
            },
            minDate: "",
            loadingEmployee: true,
            selectedEmployee: null,
            is_revisi: this.queryParams.get('is_revisi'),
            revisi_pegawai_uuid: this.queryParams.get('pegawai_uuid'),
            period_revision_uuid: this.queryParams.get('period_revision_uuid'),
            correctionTypeOptions: [],
            presenceInfo: "",
            selectedEmployeeUuid: this.peg_uuid,
            selectedDateStart: null,
            categoryOptions: [],
            selectedCategoryUuid: '',
            selectedCategoryDescription: '',
            selectedCategoryIsLimit: 0,
            selectedAdjustmentTypeCurrent: 0,
            selectedAdjustmentTypeMax: 0,
            selectedAdjustmentTypeLabel: '',
            selectedAdjustmentTypeDates: '',
            selectedEmployeeName: this.userdata ? this.userdata.employee_name : 'Pegawai',
            selectedEmployeeNip: this.userdata ? this.userdata.employee_nip : '',
            isLimitModalOpen: false,
            limitDates: [],
            isLimitExceeded: false,
            isFrontendLimitModalOpen: false,
            frontendLimitMessage: '',
            infoDescription: '',
            isValidationModalOpen: false,
            isDownloading: false,
            validationModalMessage: ''
        }
    }

    fetchCorrectionTypes = () => {
        let { selectedEmployeeUuid, selectedDateStart } = this.state
        let params = {}
        if (selectedEmployeeUuid) {
            params.employee_uuid = selectedEmployeeUuid
        }
        if (selectedDateStart) {
            params.date = moment(selectedDateStart).format('YYYY-MM-DD')
        }
        this.createBloc.fetchCorrectionTypes(params)
    }

    handleDownloadTemplate = () => {
        const { selectedEmployeeUuid, selectedDateStart, selectedCategoryUuid, selectedAdjustmentTypeId } = this.state;

        if (!selectedEmployeeUuid || !selectedDateStart || !selectedCategoryUuid || !selectedAdjustmentTypeId) {
            this.setState({
                isValidationModalOpen: true,
                validationModalMessage: 'Mohon lengkapi pilihan Pegawai, Tanggal Koreksi, Kategori Alasan, dan Alasan Koreksi terlebih dahulu sebelum mengunduh template.'
            });
            return;
        }

        const tanggalKoreksi = moment(selectedDateStart).format('YYYY-MM-DD');
        const data = {
            params: {
                employee_uuid: selectedEmployeeUuid,
                tanggal_koreksi: tanggalKoreksi,
                attendance_correction_type_uuid: selectedAdjustmentTypeId,
                attendance_correction_category_uuid: selectedCategoryUuid
            },
            responseType: 'blob'
        };

        this.setState({ isDownloading: true });
        apiRequest('get', 'Kepegawaian/koreksiKehadiran/downloadTemplate/', data)
            .then(response => {
                this.setState({ isDownloading: false });
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                const fileUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = fileUrl;
                const nipStr = this.state.selectedEmployeeNip || "NIP";
                link.setAttribute('download', `Format_Koreksi_Kehadiran_${nipStr}_${tanggalKoreksi}.docx`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }).catch(err => {
                this.setState({ isDownloading: false });
                console.error(err);
                this.setState({
                    isValidationModalOpen: true,
                    validationModalMessage: 'Gagal mengunduh template permohonan. Pastikan sesi Anda aktif.'
                });
            });
    }

    evaluateLimit = (overrides = {}) => {
        let isLimit = overrides.hasOwnProperty('selectedCategoryIsLimit') ? overrides.selectedCategoryIsLimit : this.state.selectedCategoryIsLimit;
        let current = overrides.hasOwnProperty('selectedAdjustmentTypeCurrent') ? overrides.selectedAdjustmentTypeCurrent : this.state.selectedAdjustmentTypeCurrent;
        let max = overrides.hasOwnProperty('selectedAdjustmentTypeMax') ? overrides.selectedAdjustmentTypeMax : this.state.selectedAdjustmentTypeMax;
        let label = overrides.hasOwnProperty('selectedAdjustmentTypeLabel') ? overrides.selectedAdjustmentTypeLabel : this.state.selectedAdjustmentTypeLabel;
        let dates = overrides.hasOwnProperty('selectedAdjustmentTypeDates') ? overrides.selectedAdjustmentTypeDates : this.state.selectedAdjustmentTypeDates;
        let empName = overrides.hasOwnProperty('selectedEmployeeName') ? overrides.selectedEmployeeName : (this.state.selectedEmployeeName || "Pegawai");
        let infoDesc = overrides.hasOwnProperty('infoDescription') ? overrides.infoDescription : this.state.infoDescription;

        let isExceeded = isLimit === 1 && current >= max && max > 0;
        let message = isExceeded ? `${empName} sudah ${current}x melakukan koreksi dengan jenis ${label} pada tanggal (${dates}), batas maksimum (${max}x dalam 1 Bulan)` : '';

        this.setState({
            ...overrides,
            isLimitExceeded: isExceeded,
            isFrontendLimitModalOpen: isExceeded,
            frontendLimitMessage: message
        });
    }

    handleEmployeeChange = (opt) => {
        let empNip = opt.label ? opt.label.split(' - ')[0] : "";
        let empName = opt.label ? opt.label.split(' - ')[1] : "Pegawai";
        this.setState({ selectedEmployeeUuid: opt.value, selectedEmployeeName: empName, selectedEmployeeNip: empNip }, () => {
            this.evaluateLimit();
            this.fetchCorrectionTypes();
        });
    }

    handleDateChange = (date) => {
        this.setState({ selectedDateStart: date, selectedUangMakan: undefined }, () => {
            this.evaluateLimit();
            this.fetchCorrectionTypes();
        });
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values, attendance_correction_employee_uuid: this.peg_uuid,
                is_revisi: this.state.is_revisi
            },
            confirm: true
        })
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, ['file', 'attendance_correction_document_request_uuid'])
        await this.createBloc.fetchCreate(dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    getCity = (province_uuid) => {
        this.indexBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ cityOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })
        const query = {
            is_local: 1,
            type: 3,
            parent_uuid: province_uuid
        }
        this.indexBloc.fetchRegionCity(query, this.source.token)
    }

    loadDinas = async () => {
        const query = { uuid: this.peg_uuid }
        this.createBloc.fetchDinas(query, this.source.token)
    }

    loadProvince = async () => {
        const query = {
            parent_uuid: '61b47307-167d-489f-bb6c-c1c9662acab3',
            type: 2
        }
        await this.indexBloc.fetchRegionProvince(query, this.source.token)
    }

    loadEmployeeList = async () => {
        let offset = (this.state.employeeFilter.page_number - 1) * this.state.employeeFilter.page_size
        const query = {
            search: this.state.employeeFilter.filter_value,
            limit: this.state.employeeFilter.page_size,
            offset: offset,
            order: this.state.employeeFilter.sort_order.column,
            sort: this.state.employeeFilter.sort_order.order,
            status: 1
        }
        this.setState({ loadingEmployee: true })
        await this.indexBloc.fetchEmployeeList(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.fetchCorrectionTypes()
    }

    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ provinceOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.createBloc.dinasChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ dinas: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    if (result.data && result.data.response && result.data.response.is_limit_exceeded) {
                        this.setState({
                            loading: false,
                            isLimitModalOpen: true,
                            limitDates: result.data.response.limit_dates,
                            confirm: false
                        });
                    } else {
                        this.setState({
                            loading: false,
                            failed: true,
                            failedInfo: (result.data && result.data.message) ? result.data.message : "Data gagal disimpan",
                            confirm: false
                        });
                    }
                    break
                default:
                    break
            }
        })

        this.createBloc.getMinDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    console.log(response)
                    this.setState({ minDate: response.min_date });
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.createBloc.fetchMinDate({ day: 3 })

        this.createBloc.correctionTypesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let res = result.data.response;
                    let info = res.presence_info || "";
                    let opts = res.result.map((item) => ({
                        value: item.correction_type_uuid,
                        label: item.correction_type_name,
                        isdisabled: item.is_disabled,
                        max: item.correction_type_max,
                        current: item.current_month_count,
                        dates: item.current_month_dates ? item.current_month_dates.join(", ") : "",
                        uangMakan: item.correction_type_is_uang_makan
                    }));
                    let catOpts = [];
                    if (res.categories) {
                        catOpts = res.categories.map((item) => ({
                            value: item.correction_type_categories_uuid,
                            label: item.correction_type_categories_name,
                            description: item.correction_type_categories_description,
                            is_limit: item.correction_type_categories_is_limit
                        }));
                    }

                    
                    let newAdjustmentTypeVal = null;
                    if (info.includes("(Koreksi Jam Masuk dan Jam Pulang)")) {
                        newAdjustmentTypeVal = 3;
                    } else if (info.includes("(Koreksi Jam Masuk)")) {
                        newAdjustmentTypeVal = 1;
                    } else if (info.includes("(Koreksi Jam Pulang)")) {
                        newAdjustmentTypeVal = 2;
                    }

                    this.setState({
                        adjustmentTypeVal: newAdjustmentTypeVal
                    });

                    let currentAdjMax = this.state.selectedAdjustmentTypeMax;

                    let currentAdjCurrent = this.state.selectedAdjustmentTypeCurrent;
                    let currentAdjDates = this.state.selectedAdjustmentTypeDates;
                    let currentAdjLabel = this.state.selectedAdjustmentTypeLabel;

                    if (this.state.selectedAdjustmentTypeId) {
                        let match = opts.find(o => o.value === this.state.selectedAdjustmentTypeId);
                        if (match) {
                            currentAdjMax = match.max;
                            currentAdjCurrent = match.current;
                            currentAdjDates = match.dates;
                            currentAdjLabel = match.label;
                        }
                    }

                    this.evaluateLimit({
                        correctionTypeOptions: opts,
                        presenceInfo: info,
                        categoryOptions: catOpts,
                        selectedAdjustmentTypeMax: currentAdjMax,
                        selectedAdjustmentTypeCurrent: currentAdjCurrent,
                        selectedAdjustmentTypeDates: currentAdjDates,
                        selectedAdjustmentTypeLabel: currentAdjLabel,
                        infoDescription: res.info_description || ""
                    });
                    break;
                default:
                    break;
            }
        })
        this.fetchCorrectionTypes()
    }


    customRow = (options) => {
        const listItems = options.map((cusRow, index) => (
            <Row className="mb-4">
                <Label htmlFor="horizontal-password-input" className="col-md-2 col-form-label"></Label>
                <Col sm={4}>
                    <Select
                        name={`official_travel_participant_employee_uuid[${index + 1}]`}
                        placeholder="Pilih Partisipan"
                        errorMessage="Silahkan Pilih Partisipan"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        options={this.state.employeeOption}
                        // optionLabel={opt => opt.employee_name + ' - ' + opt.employee_current_position_name}
                        // optionValue="employee_uuid"
                        onInputChange={value => this.handleSelectInputChange(value)}
                    />
                </Col>
                <Col sm={1}>
                    <Button color="danger" type="button" title="Hapus participant" onClick={(e) => this.handleDelete(index, e)}>
                        <i className="uil-minus"></i>
                    </Button>
                </Col>
            </Row>
        )
        );
        return (
            listItems
        )
    }

    handleDelete = (index, e) => {
        let stateClone = JSON.parse(JSON.stringify(this.state.options));
        stateClone.splice(index, 1);
        this.setState({ options: stateClone });
        e.preventDefault();
    }

    handleClick = (e) => {
        let stateClone = JSON.parse(JSON.stringify(this.state));
        stateClone.options.push(this.defaultOption);
        this.setState({ options: stateClone.options });
        e.preventDefault();
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)
        console.log(value)
        this.state.employeeFilter.filter_value = value

        this.timer = setTimeout(() => this.loadEmployeeList(), 800);
    }


    customRow = (options) => {
        const listItems = options.map((cusRow, index) => (
            <Row className="mb-4">
                <Label htmlFor="horizontal-password-input" className="col-md-2 col-form-label"></Label>
                <Col sm={4}>
                    <Select
                        name={`official_travel_participant_employee_uuid[${index + 1}]`}
                        placeholder="Pilih Partisipan"
                        errorMessage="Silahkan Pilih Partisipan"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        options={this.state.employeeOption}
                        // optionLabel={opt => opt.employee_name + ' - ' + opt.employee_current_position_name}
                        // optionValue="employee_uuid"
                        onInputChange={value => this.handleSelectInputChange(value)}
                    />
                </Col>
                <Col sm={1}>
                    <Button color="danger" type="button" title="Hapus participant" onClick={(e) => this.handleDelete(index, e)}>
                        <i className="uil-minus"></i>
                    </Button>
                </Col>
            </Row>
        )
        );
        return (
            listItems
        )
    }

    render() {
        let { options, dinas } = this.state;
        let { result } = this.state.employeeOption
        const correctionType = [
            { value: 2, label: 'Dibayar' },
            { value: 1, label: 'Tidak Dibayar' },
        ]
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        {
                                            this.state.is_revisi == 1 ?
                                                <Link to={`/kepegawaian/revisi_keuangan.html?create_revisi&uuid=` + this.state.period_revision_uuid + `&pegawai_uuid=` + this.state.revisi_pegawai_uuid}>
                                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                                </Link>
                                                :
                                                <Link to='/izinpegawai/koreksikehadiran.html'>
                                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                                </Link>
                                        }

                                    </div>
                                    <CardTitle>Input Koreksi Kehadiran</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        {this.state.infoDescription ? (
                                            <Alert color="info" role="alert">
                                                <div dangerouslySetInnerHTML={{ __html: this.state.infoDescription }} />
                                            </Alert>
                                        ) : (
                                            <Alert color="info" role="alert">
                                                <p><strong>KOREKSI KEHADIRAN</strong></p>
                                            </Alert>
                                        )}

                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">
                                                Kategori Alasan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <Select
                                                    name="attendance_correction_category_uuid"
                                                    placeholder="Pilih Kategori"
                                                    errorMessage="Pilih Kategori Alasan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.categoryOptions}
                                                    isSearchable={false}
                                                    onChange={(opt) => {
                                                        this.evaluateLimit({
                                                            selectedCategoryUuid: opt.value,
                                                            selectedCategoryDescription: opt.description,
                                                            selectedCategoryIsLimit: opt.is_limit
                                                        });
                                                    }}
                                                />
                                                {this.state.selectedCategoryDescription && (
                                                    <div className="mt-2 text-muted" style={{ fontSize: '0.9em' }}>
                                                        <strong>Dokumen Pendukung Wajib:</strong> <br />
                                                        <span dangerouslySetInnerHTML={{ __html: this.state.selectedCategoryDescription }}></span>
                                                    </div>
                                                )}
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Koreksi <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                {
                                                    this.state.minDate == "" ?
                                                        <Shimmer>
                                                            <div style={{ width: "100%", height: 40 }}></div>
                                                        </Shimmer>
                                                        :
                                                        <DatePicker
                                                            name={`attendance_correction_date`}
                                                            isWeekday={true}
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholder="Tanggal Koreksi"
                                                            errorMessage="Masukan Tanggal Koreksi"
                                                            validate={{ required: { value: true } }}
                                                            minDate={this.state.minDate}
                                                            maxDate={moment().format('YYYY-MM-DD')}
                                                            excludeDates={this.state.holidays_format_date}
                                                            onChange={date => this.handleDateChange(date)}
                                                        />
                                                }
                                            </Col>
                                        </Row>

                                        {this.state.presenceInfo && (
                                            <Row className="mb-3">
                                                <Col md="2"></Col>
                                                <Col md="8">
                                                    <Alert color="warning" style={{ whiteSpace: "pre-wrap" }}>
                                                        <i className="fa fa-info-circle me-1"></i> Informasi Presensi<br></br>
                                                        {this.state.presenceInfo}
                                                    </Alert>
                                                </Col>
                                            </Row>
                                        )}

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Jenis Koreksi <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <Select
                                                    key={this.state.selectedDateStart ? this.state.selectedDateStart.toString() : 'jenis-koreksi'}
                                                    name="attendance_correction_type_uuid"
                                                    placeholder="Pilih Alasan Koreksi"
                                                    errorMessage="Pilih Alasan Koreksi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.correctionTypeOptions}
                                                    isSearchable={false}
                                                    isOptionDisabled={(option) => option.isdisabled}
                                                    onChange={(opt) => {
                                                        this.evaluateLimit({
                                                            selectedAdjustmentTypeId: opt.value,
                                                            selectedAdjustmentTypeCurrent: opt.current,
                                                            selectedAdjustmentTypeMax: opt.max,
                                                            selectedAdjustmentTypeLabel: opt.label,
                                                            selectedAdjustmentTypeDates: opt.dates
                                                        });
                                                        this.setState({ selectedUangMakan: opt.uangMakan });
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                        {this.state.selectedUangMakan !== undefined && (
                                            <Row className="mb-3">
                                                <Label className="col-md-2 col-form-label">
                                                    Uang Makan
                                                </Label>
                                                <Col md="4">
                                                    <div className="form-control-plaintext">
                                                        <strong className={this.state.selectedUangMakan == 1 ? 'text-success' : 'text-danger'}>
                                                            {this.state.selectedUangMakan == 1 ? 'Dibayar' : 'Tidak Dibayar'}
                                                        </strong>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}
                                        <AvField type="hidden" name="attendance_correction_adjustment_type" value={this.state.adjustmentTypeVal} />
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Template Dokumen Permohonan
                                            </Label>
                                            <Col md="4">
                                                <Button
                                                    color="info"
                                                    type="button"
                                                    outline
                                                    disabled={this.state.isDownloading}
                                                    onClick={this.handleDownloadTemplate}
                                                >
                                                    {this.state.isDownloading ? (
                                                        <><i className="uil-spinner-alt uil-spin"></i> Mendownload...</>
                                                    ) : (
                                                        <><i className="uil-file-download"></i> Download Template Dokumen Permohonan Pelanggaran Hari dan Jam Kerja</>
                                                    )}
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="4">
                                                <AvField
                                                    name="is_revisi"
                                                    placeholder="is_revisi"
                                                    type="hidden"
                                                    value={this.state.is_revisi}
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                />
                                                <AvField
                                                    name="period_revision_uuid"
                                                    placeholder="period_revision_uuid"
                                                    type="hidden"
                                                    value={this.state.period_revision_uuid}
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Dokumen Pendukung <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <FileInput
                                                    name="file"
                                                    col="12"
                                                    accept="image/*,application/pdf"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Dokumen Permohonan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <FileInput
                                                    name="attendance_correction_document_request_uuid"
                                                    col="12"
                                                    accept="image/*,application/pdf"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="9">
                                                <Link to='/izinpegawai/koreksikehadiran.html'>
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit" disabled={this.state.isLimitExceeded || (this.state.presenceInfo && this.state.presenceInfo.includes("Tidak Perlu Koreksi"))}>
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <Modal isOpen={this.state.isLimitModalOpen} toggle={() => this.setState({ isLimitModalOpen: false })} centered>
                    <ModalHeader toggle={() => this.setState({ isLimitModalOpen: false })}>Limit Terlampaui</ModalHeader>
                    <ModalBody>
                        <p>Maaf, pada bulan ini pegawai yang dipilih sudah melebihi limitasi pengajuan Koreksi Kehadiran dikarenakan terdapat koreksi pada tanggal:</p>
                        <ul>
                            {this.state.limitDates.map((date, idx) => (
                                <li key={idx}>{date}</li>
                            ))}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ isLimitModalOpen: false })}>Tutup</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.isFrontendLimitModalOpen} toggle={() => this.setState({ isFrontendLimitModalOpen: false })} centered>
                    <ModalHeader toggle={() => this.setState({ isFrontendLimitModalOpen: false })}>Peringatan Limit</ModalHeader>
                    <ModalBody>
                        <p>{this.state.frontendLimitMessage}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ isFrontendLimitModalOpen: false })}>Tutup</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.isValidationModalOpen} toggle={() => this.setState({ isValidationModalOpen: false })} centered>
                    <ModalHeader toggle={() => this.setState({ isValidationModalOpen: false })}>Peringatan</ModalHeader>
                    <ModalBody>
                        <p>{this.state.validationModalMessage}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ isValidationModalOpen: false })}>Tutup</Button>
                    </ModalFooter>
                </Modal>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo={this.state.failedInfo || "Data gagal disimpan"}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect && this.state.is_revisi != 1 ?
                    <Redirect to={`/izinpegawai/koreksikehadiran.html`} />
                    : ""}

                {this.state.redirect && this.state.is_revisi == 1 ?
                    <Redirect to={`/kepegawaian/revisi_keuangan.html?create_revisi&uuid=` + this.state.period_revision_uuid + `&pegawai_uuid=` + this.state.revisi_pegawai_uuid} />
                    : ""}



            </Fragment>
        )
    }


}

export default withRouter(CreateView);